import axios from 'axios';
import { IPrecallCreds, IResponse } from 'interfaces/base';
import { IClientSession, IPrecallResults, ISessionParams } from 'interfaces/client';
import { IOcrPan, IPanCardInfo } from 'interfaces/form';
import { ajax, testAjax } from 'lib/axios';

// special api
const requestCall = function(country: string, params: any, apikey: string) {
  return axios.post(`/vkyc/${country}/tenant/requestCall`, params, {
    headers: {
      'Content-Type': 'application/json',
      'X-ADVAI-KEY': apikey,
    },
  });
};

const ocrPan = function(img: any) {
  return ajax.post<IResponse<IOcrPan>>('/ocrPan', {
    img: img,
  });
};

const verifyPan = function(panFormStore: IPanCardInfo) {
  const { pan, name, birthday, fatherName } = panFormStore;
  return ajax.post<IResponse<null | { status: string }>>('/verifyPan', {
    pan,
    name,
    birthday,
    fatherName,
  });
};

const verifyAadhaar = function(aadhaarZip: any, passphrase: string) {
  return ajax.post<IResponse<null>>('/verifyAadhaar', {
    aadhaarZip: aadhaarZip.split('base64,')[1],
    passphrase,
  });
};

const cancel = function() {
  return ajax.post<IResponse<IClientSession>>('/cancel');
};

const geolocation = function(clientId: string | null, lng: string, lat: string) {
  return ajax.post<IResponse<null>>('/geolocation', {
    clientId,
    lng,
    lat,
  });
};

const session = function(params: ISessionParams) {
  return ajax.post<IResponse<IClientSession>>('/session', params);
};

const getOutboundUrl = function(agentId: string) {
  return testAjax.get<IResponse<any>>(`/outboundUrl?agentId=${agentId}`);
};

const getPrecallCredentials = function() {
  return ajax.get<IResponse<IPrecallCreds>>(`/precall/credential`);
};

const sendPrecallResults = function(results: IPrecallResults) {
  return ajax.post<IResponse<null>>(`/precall/save-log`, results);
};

const precallCancel = function() {
  return ajax.post<IResponse<null>>('/precall/cancel');
};

export const sendEventPackage = function(eventPackage: any) {
  return ajax.post<IResponse<null>>(`/event`, eventPackage);
};

export default {
  requestCall,
  ocrPan,
  verifyPan,
  verifyAadhaar,
  cancel,
  geolocation,
  session,
  getOutboundUrl,
  getPrecallCredentials,
  sendPrecallResults,
  precallCancel,
};
